import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '@app/components/button/button.module';
import { ContainerModule } from '@app/components/container/container.module';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeSectionModule } from '@app/home/homeSection/homeSection.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { DonutModule } from '@app/components/donut/donut.module';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    ContainerModule,
    HomeRoutingModule,
    HomeSectionModule,
    MatDialogModule,
    MatSlideToggleModule,
    PlIconModule,
    SharedModule,
    DonutModule,
  ],
  declarations: [HomeComponent],
})
export class HomeModule {}
